import { render } from "./RequestLogsTable.vue?vue&type=template&id=1f42feb2&scoped=true"
import script from "./RequestLogsTable.vue?vue&type=script&lang=js"
export * from "./RequestLogsTable.vue?vue&type=script&lang=js"

import "./RequestLogsTable.vue?vue&type=style&index=0&id=1f42feb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f42feb2"]])

export default __exports__